module.exports = __webpack_public_path__ + "img/winerack28.1c160476.jpg";